const START = "START";
const STOP = "STOP";

export default {
  START,
  STOP,
};
